function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classnames from 'classnames';
import classes from './icon-button.scss';
const IconButton = ({
  onClick,
  tooltipDirection,
  dataTooltip,
  tooltipClassName,
  iconClassName,
  buttonClassName,
  isActive,
  hideTooltip,
  dataButton,
  dataAttr = '',
  buttonStyles,
  onMouseOver,
  onMouseOut,
  onKeyDown,
  customChild = null,
  ariaLabel = '',
  isButtonTag = true
}) => {
  const handleClick = e => {
    e.preventDefault();
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  return /*#__PURE__*/React.createElement(RootElement, {
    className: classnames(classes.toolIcon, classes.tooltip, tooltipClassName, classes[tooltipDirection], buttonClassName, {
      [classes.isActive]: isActive,
      [classes.hideTooltip]: hideTooltip
    }),
    "data-tooltip": dataTooltip,
    onClick: handleClick,
    "data-button": dataButton,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    style: buttonStyles,
    onKeyDown: onKeyDown,
    "aria-label": ariaLabel,
    isButtonTag: isButtonTag
  }, customChild ? customChild : /*#__PURE__*/React.createElement("div", {
    "data-ext": dataAttr,
    className: classnames(iconClassName, classes.iconInner, {
      [classes.emptyBox]: !dataAttr
    })
  }));
};
const RootElement = function (props) {
  const {
      isButtonTag,
      children
    } = props,
    rest = _objectWithoutProperties(props, ["isButtonTag", "children"]);
  return isButtonTag ? /*#__PURE__*/React.createElement("button", rest, children) : /*#__PURE__*/React.createElement("div", rest, children);
};
export { IconButton };